import breakpoint from './breakpoint';
import init from './jquery.init';
import validity from './jquery.validity';
import './jquery.transitionDuration';
import $ from 'jquery';
import { showModal } from '../components/b-modal';

window.jQuery = window.$ = $;

$.showModal = showModal;

function updateScrollbarWidth() {
	var root = document.documentElement;
	root.style.setProperty('--window-scrollbar-width', (window.innerWidth - root.clientWidth) + 'px');
}
window.addEventListener('resize', updateScrollbarWidth);
$(updateScrollbarWidth);



//////////////////
// WEBPACK FOOTER
// ./src/scripts/main.js
// module id = 6
// module chunks = 0